(function () {
  'use strict';

  /* Homepage mobile search bar (snippets/rsi-home-mobile-topbar.liquid).

     The bar under the header is the ENTRY POINT to the theme's real
     search — the predictive-search component in the header, the one
     with live results — not a second search. Tapping it (or the header's
     search icon while the page is at the top) opens that real search
     "docked": assets/rsi-mobile-header.js opens it exactly as it always
     does, and the docked styles in the snippet make it sit precisely
     where this bar is, looking the same, so nothing appears to drop over
     it. Opened while scrolled down, none of this applies and the search
     pops down from the header as before.

     Nothing here reaches into the header's own logic: it only clicks the
     header's existing toggle and adds/removes one class on the header.
     Without JS the bar is still a plain working search form. */

  var bar = document.querySelector('[data-rsi-home-mobile-topbar]');
  if (!bar) return;

  var mq = window.matchMedia('(max-width: 989px)');
  var header = document.querySelector('.rsi-desktop-header');
  var toggle = document.getElementById('rsi-mobile-search-toggle');
  var form = bar.querySelector('.rsi-hmt__search');
  var input = bar.querySelector('.rsi-hmt__input');
  if (!form || !input) return;

  /* ---------- faint "typing" prompt ----------
     One prompt for one bar: while the header's real field is docked onto
     this bar it shows the very same text, written by the same ticker, so
     tapping the bar changes nothing but the cursor. The real field's own
     placeholder is put back when the search closes (it is what the
     scrolled-down search and every other page show). */
  var realInput = document.getElementById('header-search');
  var realPlaceholder = realInput ? realInput.getAttribute('placeholder') : null;
  var prompt = input.getAttribute('placeholder') || '';
  function mirrorPrompt() {
    if (!realInput || !header) return;
    var want = header.classList.contains('rsi-hmt-docked') ? prompt : realPlaceholder;
    if (want !== null && realInput.getAttribute('placeholder') !== want) realInput.setAttribute('placeholder', want);
  }
  function setPrompt(text) {
    prompt = text;
    input.setAttribute('placeholder', text);
    mirrorPrompt();
  }

  var phrases = (input.getAttribute('data-rsi-hmt-phrases') || '').split('|').filter(Boolean);
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (phrases.length && !reduce) {
    var pi = 0, ci = 0, deleting = false;
    var tick = function () {
      var word = phrases[pi];
      var wait;
      if (!deleting) {
        ci++;
        wait = ci === word.length ? 2200 : 70;
        if (ci === word.length) deleting = true;
      } else {
        ci--;
        wait = 32;
        if (ci === 0) { deleting = false; pi = (pi + 1) % phrases.length; wait = 380; }
      }
      setPrompt(word.slice(0, ci) || ' ');
      window.setTimeout(tick, wait);
    };
    input.setAttribute('placeholder', ' ');
    window.setTimeout(tick, 600);
  }

  if (!header || !toggle) return; // no real search to hand over to: stay a plain form

  // 'At the top' = this bar is still in view under the header. Judged from
  // the bar itself, not scrollY: closing the search can leave the page a
  // few pixels down, and the bar is what the docked search must line up with.
  // Also true when the page is a little scrolled but any of the bar still
  // shows below the header: docking then still puts the one search field
  // where the visitor is looking, instead of the taller old-style row.
  function atTop() { return form.offsetParent !== null ? form.getBoundingClientRect().bottom > 112 : bar.getBoundingClientRect().top > 50; }
  function searchOpen() { return header.classList.contains('rsi-mobile-search-is-open'); }
  function drawerOpen() {
    return header.classList.contains('rsi-mobile-drawer-open') || !!header.querySelector('.main-menu__disclosure.is-open');
  }

  // Every class write is guarded: classList.add/remove rewrite the class
  // attribute even when nothing changes, and an unguarded write to the
  // header from inside its own observer is an endless loop.
  function setClass(el, name, on) {
    if (el.classList.contains(name) !== on) el.classList[on ? 'add' : 'remove'](name);
  }

  var undockTimer = null;
  var dockNext = false; // the header icon was tapped at the top: dock the search it is about to open

  function sync() {
    var open = searchOpen();
    if (open && dockNext) { dockNext = false; setClass(header, 'rsi-hmt-docked', true); }
    // Un-dock a moment AFTER the search has closed, not with it: the docked
    // styles are what make the row vanish instantly. Dropping the class in
    // the same breath hands the row back to the theme's 250ms closing
    // animation while this bar is already showing again - a visible flash.
    if (!open && header.classList.contains('rsi-hmt-docked') && !undockTimer) {
      undockTimer = window.setTimeout(function () {
        undockTimer = null;
        if (!searchOpen()) setClass(header, 'rsi-hmt-docked', false);
        mirrorPrompt();
      }, 120);
    }
    setClass(bar, 'is-handed-over', open); // never two bars: gone whenever the header's search is open
    mirrorPrompt();
  }

  // Hand over to the real search.
  function handOver(evt) {
    if (!mq.matches) return;
    evt.preventDefault();
    if (atTop()) setClass(header, 'rsi-hmt-docked', true);
    if (!searchOpen()) toggle.click();
    sync();
  }

  input.setAttribute('readonly', 'readonly'); // no keyboard for this field — the real one takes focus
  input.addEventListener('click', handOver);
  input.addEventListener('keydown', function (evt) { if (evt.key === 'Enter' || evt.key === ' ') handOver(evt); });
  form.addEventListener('submit', handOver);

  // The header's own icon, tapped while at the top: dock it too (capture
  // phase, so the class is on before the header's handler opens it).
  toggle.addEventListener('click', function () {
    // Only a flag here: adding the class now would be undone by this file's
    // own observer (a microtask) before the header's handler has opened the
    // search. sync() applies it the moment the search reports open.
    if (mq.matches && atTop() && !searchOpen()) {
      dockNext = true;
      window.setTimeout(function () { dockNext = false; }, 600);
    }
  }, true);

  // header's own class (search open / drawer open) + the drawer disclosure's
  new MutationObserver(sync).observe(header, { attributes: true, attributeFilter: ['class'] });
  var disclosureEl = header.querySelector('.main-menu__disclosure');
  if (disclosureEl) new MutationObserver(sync).observe(disclosureEl, { attributes: true, attributeFilter: ['class'] });
  window.addEventListener('scroll', sync, { passive: true });
  if (mq.addEventListener) mq.addEventListener('change', sync);
  // The theme positions the page under the fixed header after this script
  // first runs, so one early reading of 'at the top' is not enough.
  window.addEventListener('load', sync);
  window.addEventListener('resize', sync);
  window.addEventListener('pageshow', sync);
  if (window.ResizeObserver) new ResizeObserver(sync).observe(header);
  [0, 300, 1200, 3000].forEach(function (ms) { window.setTimeout(sync, ms); });
})();
